// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608261304/js/" + chunkId + "." + {"44":"d1a3b862","225":"def0724a","481":"67878b63","486":"296c6eb9","770":"a074959f"}[chunkId] + ".0.5782072816373792.chunk.js";
};